import React, { useState, useEffect } from 'react';
import styles from './UserInfoCard.module.css';

const UserInfoCard = ({ user, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        euStatus: !!user.euStatus,
        verified: !!user.verified,
        dateOfBirth: user.dateOfBirth || '',
        email: user.email || '',
        phoneNumber: user.phoneNumber || '',
        coins: user.coins || 0,
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSave = () => {
    onUpdate && onUpdate(formData);
    setEditing(false);
  };

  if (!user) return null;

  const formatNumber = (num) => {
    if (num === null || num === undefined) return '0.00';
    return parseFloat(num).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.title}>👤 User Information</h2>
        {!editing && (
          <button className={styles.editButton} onClick={() => setEditing(true)}>
            ✏️ Edit
          </button>
        )}
      </div>
      {editing ? (
        <>
          <div className={styles.grid}>
            <div className={styles.field}>
              <label className={styles.label}>First Name</label>
              <input
                className={styles.input}
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Last Name</label>
              <input
                className={styles.input}
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Date of Birth</label>
              <input
                className={styles.input}
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth || ''}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Language</label>
              <input
                className={styles.input}
                name="language"
                value={user.language || ''}
                disabled
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>EU Status</label>
              <input
                type="checkbox"
                name="euStatus"
                checked={formData.euStatus}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Verified</label>
              <input
                type="checkbox"
                name="verified"
                checked={formData.verified}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Email</label>
              <input
                className={styles.input}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Phone</label>
              <input
                className={styles.input}
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Coins</label>
              <input
                className={styles.input}
                name="coins"
                value={formData.coins}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className={styles.actions}>
            <button className={styles.saveButton} onClick={handleSave}>
              💾 Save
            </button>
            <button className={styles.cancelButton} onClick={() => setEditing(false)}>
              ✖ Cancel
            </button>
          </div>
        </>
      ) : (
        <div className={styles.grid}>
          <div className={styles.field}>
            <span className={styles.label}>First Name</span>
            <span className={`${styles.value} ${!user.firstName ? styles.empty : ''}`}>{user.firstName || '-'}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Last Name</span>
            <span className={`${styles.value} ${!user.lastName ? styles.empty : ''}`}>{user.lastName || '-'}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Date of Birth</span>
            <span className={`${styles.value} ${!user.dateOfBirth ? styles.empty : ''}`}>{user.dateOfBirth || '-'}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Language</span>
            <span className={styles.value}>{user.language || '-'}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>EU Status</span>
            <span className={styles.value} style={{ color: user.euStatus ? '#00ff57' : '#ff4d4f' }}>
              {user.euStatus ? '✅' : '❌'}
            </span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Verified</span>
            <span className={styles.value} style={{ color: user.verified ? '#00ff57' : '#ff4d4f' }}>
              {user.verified ? '✅' : '❌'}
            </span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Email</span>
            <span className={`${styles.value} ${!user.email ? styles.empty : ''}`}>{user.email || '-'}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Phone</span>
            <span className={`${styles.value} ${!user.phoneNumber ? styles.empty : ''}`}>{user.phoneNumber || '-'}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Coins</span>
            <span className={`${styles.value} ${!user.coins ? styles.empty : ''}`}>{user.coins ?? '-'}</span>
          </div>
          <div className={styles.field}>
            <span className={styles.label}>Total Balance</span>
            <span className={styles.balance}>{formatNumber(user.totalBalance)} USDT</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfoCard;
